const HOST = process.env.REACT_APP_API_URL;

export const APP_CONFIG = `${HOST}/client/app-config`;

export const SEARCH_DEVICE = (sn: string) => `${HOST}/client/devices/search?search=${sn}`;

export const WEB_RENT = `${HOST}/client/rents/web`;
export const GET_RENT = (id: string) => `${HOST}/client/rents/${id}`;
